/* eslint-disable */
// Card Mutations

export const issuePaymentCard = /* GraphQL */ `
  mutation IssuePaymentCard($input: IssuePaymentCard!) {
    issuePaymentCard(input: $input) {
      statusCode
      errorMessage
      errorType
      paymentCardId
    }
  }
`;

// SEE-186: the cancel-card email, composed server-side by v2-highnote on the CDK API
// (sent by app/services/highnote.service.ts). Replaces the Amplify `sendEmail` query,
// which mailed caller-supplied to/subject/body.
export const notifyCardCanceled = /* GraphQL */ `
  mutation NotifyCardCanceled($paymentCardId: ID!) {
    notifyCardCanceled(paymentCardId: $paymentCardId) {
      sent
    }
  }
`;
